"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var oidc = __importStar(require("oidc-client"));
var environments_1 = require("./environments");
// Support for server side pre-rendering and testing
var memoryStorage = new oidc.InMemoryWebStorage();
oidc.Log.logger = console;
oidc.Log.level = oidc.Log.INFO;
var SessionManager = /** @class */ (function () {
    function SessionManager(settings) {
        var _this = this;
        this.settings = settings;
        this.user = null;
        this.eventListeners = [];
        this.basePath = "";
        this.handleUserChanged = function () { return __awaiter(_this, void 0, void 0, function () {
            var newUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        newUser = _a.sent();
                        if (newUser !== this.user) {
                            this.user = newUser;
                            this.eventListeners.forEach(function (x) { return x(); });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.handleAccessTokenExpired = function () {
            _this.userManager.removeUser();
        };
        this.basePath = settings.basePath || this.basePath;
        var defaultManagerSettings = {
            redirect_uri: "" + window.location.origin + this.basePath + "/#/signin-callback",
            post_logout_redirect_uri: "" + window.location.origin + this.basePath + "/#/logout-callback",
            silent_redirect_uri: "" + window.location.origin + this.basePath + "/silent-callback.html",
            automaticSilentRenew: settings.automaticSilentRenew === true,
            response_type: "code",
            revokeAccessTokenOnSignout: true,
            scope: "openid",
            filterProtocolClaims: true,
            loadUserInfo: true,
            userStore: new oidc.WebStorageStateStore({
                store: window.sessionStorage ? sessionStorage : memoryStorage
            }),
            stateStore: new oidc.WebStorageStateStore({
                store: window.localStorage ? localStorage : memoryStorage
            })
        };
        this.userManager = new oidc.UserManager(__assign(__assign(__assign({}, defaultManagerSettings), { authority: environments_1.environmentSettings[settings.environment].url, client_id: settings.clientId, scope: settings.scope, monitorSession: false }), (settings ? settings.overrideUserManagerSettings : {})));
    }
    SessionManager.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, result, user, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        if (!(window.location.href.indexOf(this.userManager.settings.redirect_uri) !== -1)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userManager.signinRedirectCallback()];
                    case 1:
                        _a.user = _b.sent();
                        this.navigate(this.user.state);
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(window.location.href.indexOf(this.userManager.settings.post_logout_redirect_uri) !== -1)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.userManager.signoutRedirectCallback()];
                    case 3:
                        result = _b.sent();
                        if (result.state) {
                            this.loggedOutReason = result.state.reason;
                            this.navigate(result.state.postLogoutLocation || {
                                pathname: "/",
                                hash: "",
                                search: "",
                                state: null
                            });
                        }
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.userManager.getUser()];
                    case 5:
                        user = _b.sent();
                        if (user && !user.expired) {
                            this.user = user;
                        }
                        _b.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _b.sent();
                        // Need to clear URL to avoid user getting stuck bad application state
                        this.navigate({ pathname: "/", hash: "", search: "", state: null });
                        throw error_1;
                    case 8:
                        this.userManager.events.addUserLoaded(this.handleUserChanged);
                        this.userManager.events.addUserUnloaded(this.handleUserChanged);
                        this.userManager.events.addAccessTokenExpired(this.handleAccessTokenExpired);
                        this.userManager.events.addSilentRenewError(this.handleSilentRenewError);
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionManager.prototype.navigate = function (loc) {
        this.settings.navigate(loc, loc.pathname + loc.search + loc.hash);
    };
    SessionManager.prototype.getUser = function () {
        return this.user;
    };
    SessionManager.prototype.getLoggedOutReason = function () {
        return this.loggedOutReason;
    };
    SessionManager.prototype.login = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var loc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loc = {
                            hash: window.location.hash,
                            pathname: window.location.pathname.substr(this.basePath.length, window.location.pathname.length - this.basePath.length),
                            search: window.location.search,
                            state: history.state
                        };
                        return [4 /*yield*/, this.userManager.signinRedirect(__assign(__assign({}, args), { state: loc }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionManager.prototype.logout = function (postLogoutLocation, reason) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.signoutRedirect({ state: { postLogoutLocation: postLogoutLocation, reason: reason } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionManager.prototype.dropUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.removeUser()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionManager.prototype.addUserChangedListener = function (listener) {
        this.eventListeners.push(listener);
    };
    SessionManager.prototype.handleSilentRenewError = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.error("SILENT RENEW ERROR: ", args);
    };
    return SessionManager;
}());
exports.SessionManager = SessionManager;
//# sourceMappingURL=SessionManager.js.map